

export interface IAppConfig {
    apiUrl: string;
}

export const appConfig: IAppConfig = {
    apiUrl: undefined
}
